import { ID } from "../../../_metronic/helpers"
import coreClient from "../coreClient"

export const deleteSetup= (label: string, userId: ID): Promise<void> => {
    return coreClient.delete(`/${label}/${userId}`).then(() => {})
  }
